<template>
	<o-tour :ref="setup._tourQrCode">
		<o-tour-step
			:title="$t('common.tour.qrCode.welcome.title')"
			hide-finish>
			<p>
				{{ $t('common.tour.qrCode.welcome.description') }}
			</p>
		</o-tour-step>
		<o-tour-step
			v-if="setup.hasData"
			target="qr-code-icon"
			:next="setup.showQrIconOnHover()"
			hide-finish>
			<p>
				{{ $t('common.tour.qrCode.access.clickIcon') }}
			</p>
		</o-tour-step>
		<o-tour-step
			v-if="setup.hasData"
			:end="setup.removeHover()"
			target="qr-code">
			{{ $t('common.tour.qrCode.access.orHere') }}
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
// #region Setup
import type { TourQrCodeEmits, TourQrCodeProps } from './TourQrCodeSetup';
import TourQrCodeSetup from './TourQrCodeSetup';
const emits = defineEmits<TourQrCodeEmits>() as TourQrCodeEmits;
const props = withDefaults(defineProps<TourQrCodeProps>(), TourQrCodeSetup.defaultProps);
const setup = new TourQrCodeSetup(props, emits);
// #endregion
</script>
